export const PRIMARY = "#1975d1";
export const BORDER = "#e8eaef";
export const TEXT = "#111827";
export const TEXT_SOFT = "#6b7280";

export const CHART = {
  services: "#1975d1",
  technicians: "#0f766e",
  completed: "#059669",
  cancelled: "#dc2626",
  pending: "#d97706",
  pest: "#b45309",
  quality: "#7c3aed",
  punctuality: "#0284c7",
  certificates: "#4338ca",
  load: "#0ea5e9",
};

export const TYPE_COLORS = {
  MIP: "#1D4E89",
  TICKET: "#B45309",
  NEBULIZACION: "#0F766E",
  MICROINYECCION: "#6D28D9",
  MOSCA: "#3F6212",
  ABEJA: "#A16207",
  EQUIPO: "#334155",
  CHOQUE: "#B91C1C",
  SUPERVISION: "#0369A1",
  EVENTUAL: "#9A3412",
  OTRO: "#57534E",
};

export const STATUS_COLORS = {
  PENDING: "#d97706",
  SCHEDULED: "#0288d1",
  IN_PROGRESS: "#1976d2",
  COMPLETED: "#059669",
  CANCELLED: "#dc2626",
  POSTPONED: "#78716c",
};

export const PIE_COLORS = [
  "#1D4E89", "#0F766E", "#B45309", "#6D28D9", "#9F1239",
  "#3F6212", "#0369A1", "#9A3412", "#334155", "#1975d1",
  "#64748b", "#0ea5e9",
];

export const fmt = (n) => new Intl.NumberFormat("es-MX").format(Number(n) || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-MX", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const selectSx = {
  borderRadius: "10px",
  bgcolor: "#fff",
  fontSize: "0.875rem",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: BORDER },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#d1d5db" },
};
